import useDocumentVisibility from './useDocumentVisibility';

export default useDocumentVisibility;
